module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// C:/Development/Private Projects/random-ride/RandomRide/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main